// import React from 'react'
// import { useAppSelector } from '../../../Redux Toolkit/Store'
// import AddressCard from '../Checkout/AddressCard'
// import UserAddressCard from './UserAddressCard'

// const Addresses = () => {
//     const { user } = useAppSelector(store => store)
//     return (
//         <>
//             <div className='space-y-3'>
//                 {user.user?.addresses?.map((item, index) =>
//                     <UserAddressCard
//                         key={item.id}
//                         item={item} />)}
//             </div>
//         </>
//     )
// }

// export default Addresses


// import React from "react";
// import { Plus } from "lucide-react";
// import { useAppSelector } from "../../../Redux Toolkit/Store";
// import UserAddressCard from "./UserAddressCard";

// const Addresses = () => {
//   const { user } = useAppSelector((store) => store);

//   const addresses = user.user?.addresses || [];

//   const handleAddAddress = () => {
//     alert("Add new address flow is not connected yet.");
//   };

//   const handleEditAddress = (id: number | string | undefined) => {
//     alert(`Edit address flow is not connected yet. Address ID: ${id}`);
//   };

//   const handleDeleteAddress = (id: number | string | undefined) => {
//     alert(`Delete address API is not connected yet. Address ID: ${id}`);
//   };

//   return (
//     <div className="space-y-5">
//       <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
//         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//           <div>
//             <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
//               My Addresses
//             </h1>

//             <p className="text-sm text-gray-500 mt-1">
//               Manage your saved delivery addresses
//             </p>
//           </div>

//           <button
//             onClick={handleAddAddress}
//             className="flex items-center justify-center gap-2 border border-primary-color text-primary-color rounded-lg px-4 py-2 text-sm font-medium hover:bg-gray-100 transition"
//           >
//             <Plus size={17} />
//             Add New Address
//           </button>
//         </div>
//       </div>

//       {addresses.length > 0 ? (
//         <div className="space-y-4">
//           {addresses.map((item, index) => (
//             <UserAddressCard
//               key={item.id || index}
//               item={item}
//               onEdit={() => handleEditAddress(item.id)}
//               onDelete={() => handleDeleteAddress(item.id)}
//             />
//           ))}
//         </div>
//       ) : (
//         <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8 text-center">
//           <h2 className="text-lg font-semibold text-gray-900">
//             No address added yet
//           </h2>

//           <p className="text-sm text-gray-500 mt-1">
//             Add a new address to make checkout faster.
//           </p>

//           <button
//             onClick={handleAddAddress}
//             className="mt-5 border border-primary-color text-primary-color rounded-lg px-5 py-2 text-sm font-medium hover:bg-gray-100 transition"
//           >
//             Add New Address
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Addresses;



// import React, { useState } from "react";
// import { Plus } from "lucide-react";
// import { Box, Modal } from "@mui/material";
// import { useAppSelector } from "../../../Redux Toolkit/Store";
// import UserAddressCard from "./UserAddressCard";
// import AddressForm from "../Checkout/AddresssForm";
// import { Address } from "../../../types/userTypes";

// const modalStyle = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: "92%", sm: 520 },
//   maxHeight: "90vh",
//   overflowY: "auto",
//   bgcolor: "background.paper",
//   boxShadow: 24,
//   borderRadius: "16px",
//   p: 4,
// };

// const Addresses = () => {
//   const { user } = useAppSelector((store) => store);
//   const [open, setOpen] = useState(false);

//   const addresses = user.user?.addresses || [];

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const handleAddressSubmit = (address: Address) => {
//     console.log("Profile address form submitted:", address);
//     alert("Address API is not connected yet.");
//   };

//   const handleEditAddress = (id: number | string | undefined) => {
//     alert(`Edit address flow is not connected yet. Address ID: ${id}`);
//   };

//   const handleDeleteAddress = (id: number | string | undefined) => {
//     alert(`Delete address API is not connected yet. Address ID: ${id}`);
//   };

//   return (
//     <div className="space-y-5">
//       <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 sm:p-6">
//         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//           <div>
//             <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
//               My Addresses
//             </h1>

//             <p className="text-sm text-gray-500 mt-1">
//               Manage your saved delivery addresses
//             </p>
//           </div>

//           <button
//             onClick={handleOpen}
//             className="flex items-center justify-center gap-2 border border-primary-color text-primary-color rounded-lg px-4 py-2 text-sm font-medium hover:bg-gray-100 transition"
//           >
//             <Plus size={17} />
//             Add New Address
//           </button>
//         </div>
//       </div>

//       {addresses.length > 0 ? (
//         <div className="space-y-4">
//           {addresses.map((item, index) => (
//             <UserAddressCard
//               key={item.id || index}
//               item={item}
//               onEdit={() => handleEditAddress(item.id)}
//               onDelete={() => handleDeleteAddress(item.id)}
//             />
//           ))}
//         </div>
//       ) : (
//         <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8 text-center">
//           <h2 className="text-lg font-semibold text-gray-900">
//             No address added yet
//           </h2>

//           <p className="text-sm text-gray-500 mt-1">
//             Add a new address to make checkout faster.
//           </p>

//           <button
//             onClick={handleOpen}
//             className="mt-5 border border-primary-color text-primary-color rounded-lg px-5 py-2 text-sm font-medium hover:bg-gray-100 transition"
//           >
//             Add New Address
//           </button>
//         </div>
//       )}

//       <Modal open={open} onClose={handleClose}>
//         <Box sx={modalStyle}>
//           <AddressForm
//             mode="profile"
//             handleClose={handleClose}
//             onAddressSubmit={handleAddressSubmit}
//           />
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Addresses;



// import React, { useEffect, useState } from "react";
// import { Plus } from "lucide-react";
// import { Box, Modal } from "@mui/material";
// import { useAppSelector } from "../../../Redux Toolkit/Store";
// import UserAddressCard from "./UserAddressCard";
// import AddressForm from "../Checkout/AddresssForm";
// import { Address } from "../../../types/userTypes";

// const modalStyle = {
//   position: "fixed" as const,
//   top: "52%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "calc(100% - 24px)",
//   maxWidth: "620px",
//   outline: "none",
//   bgcolor: "transparent",
//   boxShadow: "none",
//   p: 0,
//   overflow: "hidden",
// };

// const Addresses = () => {
//   const { user } = useAppSelector((store) => store);
//   const [open, setOpen] = useState(false);

//   const addresses = user.user?.addresses || [];

//   const handleOpen = () => {
//     setOpen(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleClose = () => {
//     setOpen(false);
//     document.body.style.overflow = "";
//   };

//   useEffect(() => {
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, []);

//   const handleAddressSubmit = (address: Address) => {
//     console.log("Profile address form submitted:", address);
//     alert("Address API is not connected yet.");
//   };

//   const handleEditAddress = (id: number | string | undefined) => {
//     alert(`Edit address flow is not connected yet. Address ID: ${id}`);
//   };

//   const handleDeleteAddress = (id: number | string | undefined) => {
//     alert(`Delete address API is not connected yet. Address ID: ${id}`);
//   };

//   return (
//     <div className="space-y-5">
//       <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6">
//         <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
//           <div>
//             <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">
//               My Addresses
//             </h1>

//             <p className="mt-1 text-sm text-gray-500">
//               Manage your saved delivery addresses
//             </p>
//           </div>

//           <button
//             onClick={handleOpen}
//             className="flex items-center justify-center gap-2 rounded-lg border border-primary-color px-4 py-2 text-sm font-medium text-primary-color transition hover:bg-gray-100"
//           >
//             <Plus size={17} />
//             Add New Address
//           </button>
//         </div>
//       </div>

//       {addresses.length > 0 ? (
//         <div className="space-y-4">
//           {addresses.map((item, index) => (
//             <UserAddressCard
//               key={item.id || index}
//               item={item}
//               onEdit={() => handleEditAddress(item.id)}
//               onDelete={() => handleDeleteAddress(item.id)}
//             />
//           ))}
//         </div>
//       ) : (
//         <div className="rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
//           <h2 className="text-lg font-semibold text-gray-900">
//             No address added yet
//           </h2>

//           <p className="mt-1 text-sm text-gray-500">
//             Add a new address to make checkout faster.
//           </p>

//           <button
//             onClick={handleOpen}
//             className="mt-5 rounded-lg border border-primary-color px-5 py-2 text-sm font-medium text-primary-color transition hover:bg-gray-100"
//           >
//             Add New Address
//           </button>
//         </div>
//       )}

//       <Modal open={open} onClose={handleClose} disableScrollLock>
//         <Box sx={modalStyle}>
//           <AddressForm
//             mode="profile"
//             handleClose={handleClose}
//             onAddressSubmit={handleAddressSubmit}
//           />
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Addresses;





import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { Box, Modal } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import UserAddressCard from "./UserAddressCard";
import AddressForm from "../Checkout/AddresssForm";
import { Address } from "../../../types/userTypes";
import {
  addUserAddress,
  deleteUserAddress,
  fetchUserAddresses,
  updateUserAddress,
} from "../../../Redux Toolkit/Customer/UserSlice";

const modalStyle = {
  position: "fixed" as const,
  top: "52%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 24px)",
  maxWidth: "620px",
  outline: "none",
  bgcolor: "transparent",
  boxShadow: "none",
  p: 0,
  overflow: "hidden",
};

const Addresses = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((store) => store);

  const [open, setOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);

  const addresses = user.user?.addresses || [];

  const handleOpen = () => {
    setSelectedAddress(null);
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedAddress(null);
    document.body.style.overflow = "";
  };

  useEffect(() => {
    const jwt = localStorage.getItem("jwt") || "";

    if (jwt) {
      dispatch(fetchUserAddresses({ jwt }));
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [dispatch]);

  const handleAddressSubmit = async (address: Address) => {
    const jwt = localStorage.getItem("jwt") || "";

    if (!jwt) return;

    if (selectedAddress?.id) {
      await dispatch(
        updateUserAddress({
          jwt,
          addressId: Number(selectedAddress.id),
          address,
        })
      );
    } else {
      await dispatch(
        addUserAddress({
          jwt,
          address,
        })
      );
    }

    handleClose();
  };

  const handleEditAddress = (address: Address) => {
    setSelectedAddress(address);
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleDeleteAddress = async (id: number | string | undefined) => {
    if (!id) return;

    const jwt = localStorage.getItem("jwt") || "";

    if (!jwt) return;

    await dispatch(
      deleteUserAddress({
        jwt,
        addressId: Number(id),
      })
    );
  };

  return (
    <div className="space-y-5">
      <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">
              My Addresses
            </h1>

            <p className="mt-1 text-sm text-gray-500">
              Manage your saved delivery addresses
            </p>
          </div>

          <button
            onClick={handleOpen}
            className="flex items-center justify-center gap-2 rounded-lg border border-primary-color px-4 py-2 text-sm font-medium text-primary-color transition hover:bg-gray-100"
          >
            <Plus size={17} />
            Add New Address
          </button>
        </div>
      </div>

      {addresses.length > 0 ? (
        <div className="space-y-4">
          {addresses.map((item: Address, index: number) => (
            <UserAddressCard
              key={item.id || index}
              item={item}
              onEdit={() => handleEditAddress(item)}
              onDelete={() => handleDeleteAddress(item.id)}
            />
          ))}
        </div>
      ) : (
        <div className="rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
          <h2 className="text-lg font-semibold text-gray-900">
            No address added yet
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Add a new address to make checkout faster.
          </p>

          <button
            onClick={handleOpen}
            className="mt-5 rounded-lg border border-primary-color px-5 py-2 text-sm font-medium text-primary-color transition hover:bg-gray-100"
          >
            Add New Address
          </button>
        </div>
      )}

      <Modal open={open} onClose={handleClose} disableScrollLock>
        <Box sx={modalStyle}>
          <AddressForm
            mode="profile"
            handleClose={handleClose}
            onAddressSubmit={handleAddressSubmit}
            initialAddress={selectedAddress}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default Addresses;